import { Flex, Text } from '@mantine/core';

type ItemPointProps = {
  subTitle?: string;
  title?: string;
  text: React.ReactNode;
};

export const ItemPoint = ({ title, subTitle, text }: ItemPointProps) => {
  return (
    <Flex rowGap={8} direction='column'>
      <Text size='sm' c='tertiary.7'>
        {subTitle}
      </Text>

      <Flex direction='column'>
        <Text c='primary.7' fw={600} mb={16}>
          {title}
        </Text>

        <Text c='primary.7'>{text}</Text>
      </Flex>
    </Flex>
  );
};
